const pattern = /%(?:\d\$)?s/

/**
 * Given a string, return a curried function that accepts a variadic set of strings
 * @param  {string}              string   String to be replaced
 * @return {function<...string, ...node>} Function accepting strings or react nodes
 */
const makeSprintf = string => (...glue) => {
  if (glue.every(s => typeof s === 'string')) {
    return glue.reduce((str, replacement) => str.replace(pattern, replacement), string)
  }
  return string.split(pattern).reduce((all, child, index) => (
    <span>
      {all}
      {child}
      {glue[index] || null}
    </span>
  ), null)
}

// If we're testing, we can stub this function out.
// Otherwise, we access a key on the __I18N__ global via passed string.
const I18n = (str) => {
  const result = window.MV_CREATE_I18N[str.toUpperCase().replace(' ', '_')]
  if (!result) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`No i18n provided for: ${str}`) // eslint-disable-line
    }
    return () => ''
  }
  return result.match(pattern) ? makeSprintf(result) : result
}
const mockI18n = str => str
const __ = (process.env.NODE_ENV !== 'test') ? I18n : mockI18n // eslint-disable-line

export default __
